import { Pending } from "@indietabletop/appkit";
import useSWR, { type SWRResponse } from "swr";
import useSWRImmutable from "swr/immutable";

export async function fetcher(url: string) {
  const response = await fetch(url);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return await response.json();
}

export function swrResponseToResult<T>(response: SWRResponse<T, unknown>) {
  const { data } = response;

  if (data) {
    return data;
  }

  return new Pending();
}

export function useFetcher<T = unknown>(url: string) {
  const response = useSWR<T, unknown>(url, fetcher);
  return swrResponseToResult(response);
}

export function useImmutableFetcher<T = unknown>(url: string) {
  return useSWRImmutable<T, unknown>(url, fetcher);
}
